export enum AddableType {
  Dish = 1,
  Handle = 2,
  TrolleyHandle = 3,
  Foot = 4,
  Runner = 5,
  Cutout = 6,
}
